import React, { useState } from 'react';
import { UserService } from '../../services';
import { isSuccessfulResponse } from '../../utils/responseHelpers';
import { useNotification } from '../../contexts/NotificationContext';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import { IconButton, Tooltip } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import ConfirmationModal from '../../components/ConfirmationModal';

const LockedUserCell = (props) => {
    const { createErrorNotification } = useNotification();
    const [showWaitMessage, setShowWaitMessage] = useState(false);
    const [showConfirmationBox, setShowConfirmationBox] = useState(false);

    const toggleConfirmation = () => setShowConfirmationBox((prev) => !prev);

    const closeWaitMessage = () => {
        setShowWaitMessage(false);
    }

    const handleUnlockClick = () => toggleConfirmation();

    const handleConfirmUnlock = async () => {
        try {
            const response = await UserService.unlockUser(props.id);
            if (isSuccessfulResponse(response)) {
                setShowWaitMessage(true);
                setTimeout(() => window.location.reload(), 2000);
            } else {
                createErrorNotification("Failed to unlock user.");
            }
        } catch (err) {
            createErrorNotification("Failed to unlock user.");
        }
        toggleConfirmation();
    }

    if (!props.value) {
        return (
            <Tooltip title="User is not locked">
                <LockOpenIcon color="disabled" />
            </Tooltip>
        );
    }

    return (
        <div>
            <Snackbar open={showWaitMessage} autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={closeWaitMessage} severity="success">
                    {"Unlocking user. Changes will appear in a few seconds."}
                </Alert>
            </Snackbar>
            <Tooltip title="Click to unlock user">
                <IconButton onClick={handleUnlockClick} size="small">
                    <LockIcon color="error" />
                </IconButton>
            </Tooltip>
            <ConfirmationModal title="Confirm" message="Are you sure you want to unlock this user?" onConfirm={handleConfirmUnlock} onCancel={toggleConfirmation} showConfirmationBox={showConfirmationBox}/>
        </div>
    )
}

export default LockedUserCell;
